import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { connect } from "react-redux";
import { getEventShifts } from "store/actions/shifts";

const TiersHeader = (props) => {
  const {
    shiftList,
    triggerGetEventShifts,
    setSelectedRoleUUID
  } = props;

  const [shiftData, setShiftData] = useState([]);
  const [selectedShift, setSelectedShift] = useState("");
  const [selectedRoleName, setSelectedRoleName] = useState("");

  const { id } = useParams();

  // Group roles by shift
  const groupRolesByShift = (shiftList) => {
    const grouped = {};

    shiftList.forEach((event) => {
      const shiftName = event.name || "";
      const roles = event.roles || [];

      if (!grouped[shiftName]) {
        grouped[shiftName] = [];
      }

      roles.forEach((role) => {
        grouped[shiftName].push({
          roleName: role.event_role?.name || "",
          roleUUID: role.uuid || "",
        });
      });
    });

    return Object.entries(grouped).map(([shiftName, roles]) => ({
      shiftName,
      roles,
    }));
  };

  useEffect(() => {
    if (shiftList?.length) {
      updateShiftData()
    } else {
      getUpdatedShiftList()
    }
  }, [shiftList]);

  const updateShiftData = () => {
    const grouped = groupRolesByShift(shiftList);
    setShiftData(grouped);

    const storedRoleUUID = sessionStorage.getItem("selectedRoleUUID");

    let foundShift = "";
    let foundRole = null;

    if (storedRoleUUID) {
      for (const shift of grouped) {
        const role = shift.roles.find(r => r.roleUUID === storedRoleUUID);
        if (role) {
          foundShift = shift.shiftName;
          foundRole = role;
          break;
        }
      }
    }

    if (!foundRole) {
      foundShift = grouped[0]?.shiftName || "";
      foundRole = grouped[0]?.roles[0] || {};
    }

    setSelectedShift(foundShift);
    setSelectedRoleName(foundRole?.roleName || "");
    setSelectedRoleUUID(foundRole?.roleUUID || "");
  };

  const getUpdatedShiftList = () => {
    const payload = {
      id,
      onSuccess: (response) => {},
      onError: (error) => {}
    };

    triggerGetEventShifts(payload);
  }

  const shiftCustomStyle = (shift) => {
    return shift === selectedShift
      ? "text-secondary border-secondary border-b-3 cursor-pointer"
      : "text-policeBlue border-white border-b-3 cursor-pointer";
  };

  const roleCustomStyle = (roleName) => {
    return roleName === selectedRoleName
      ? "text-secondary border-secondary border-b-3 cursor-pointer"
      : "text-policeBlue border-white border-b-3 cursor-pointer";
  };

  const onShiftClick = (shiftName) => {
    setSelectedShift(shiftName);

    const shiftObj = shiftData.find((s) => s.shiftName === shiftName);
    const firstRoleObj = shiftObj?.roles[0] || {}; 

    setSelectedRoleName(firstRoleObj.roleName);
    setSelectedRoleUUID(firstRoleObj.roleUUID || "");
    sessionStorage.setItem("selectedRoleUUID", firstRoleObj.roleUUID || "");
  };

  const onRoleClick = (roleObj) => {
    setSelectedRoleName(roleObj.roleName);
    setSelectedRoleUUID(roleObj.roleUUID);
    sessionStorage.setItem("selectedRoleUUID", roleObj.roleUUID);
  };

  return (
    <>
      <h1 className="font-inter font-semibold text-2xl text-left mb-4">Tiers</h1>

      {/* Shifts */}
      <div className="flex border-b border-grayLight gap-6">
        {shiftData.map((shift) => (
          <button
            key={shift.shiftName}
            className={`flex items-center py-2 justify-center text-lg ${shiftCustomStyle(
              shift.shiftName
            )}`}
            onClick={() => onShiftClick(shift.shiftName)}
          >
            {shift.shiftName}
          </button>
        ))}
      </div>

      {/* Roles for selected shift */}
      {selectedShift && (
        <div className="flex border-b border-grayLight gap-6 mt-3">
          {shiftData
            .find((s) => s.shiftName === selectedShift)
            ?.roles.map((roleObj) => (
              <button
                key={roleObj.roleUUID}
                className={`flex items-center py-2 justify-center text-sm ${roleCustomStyle(
                  roleObj.roleName
                )}`}
                onClick={() => onRoleClick(roleObj)}
              >
                {roleObj.roleName}
              </button>
            ))}
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    shiftList: state.shifts.shiftList,
  };
};

const mapDispatchToProps = {
  triggerGetEventShifts: getEventShifts
};

export default connect(mapStateToProps, mapDispatchToProps)(TiersHeader);
